import React, { useEffect, useState } from 'react';
import './email.component.scss';
import CustomModal from 'dedicated/components/customModal/customModal';
import { sendPricingProposal } from '../../../../common/helper/api.helper';
import { getFromSessionStorage } from 'common/utils/app.utils';
import { DEDICATED_FEASIBILITY_RESPONSE, MODULE_ID, DEDICATED_CUSTOMER_DETAIL } from 'home/common/constants/constants';
import { EmailPricingProposal } from 'common/components/email-pricing-proposal/email-pricing-proposal.component';
const EmailProposal = ({}) => {
  const customerDetails = getFromSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL);
  let getPrice = getFromSessionStorage(MODULE_ID, 'sendQuotation');
  let getArc = getPrice && getPrice.price && getPrice.price.amount ? getPrice.price.amount : 0;
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const [disabled, setButtonDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const openConfirmationPopup = () => {
    setConfirmationPopup(!confirmationPopup);
  };

  const sendProposal = (email) => {
    setButtonDisabled(true);
    let sendQuotation = getFromSessionStorage(MODULE_ID, 'sendQuotation');
    let feasibilityResponse = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
    let address = feasibilityResponse && feasibilityResponse.address;
    let otc = sendQuotation && sendQuotation.price && sendQuotation.price.otc ? sendQuotation.price.otc : 0;
    let arc = sendQuotation && sendQuotation.price && sendQuotation.price.amount ? sendQuotation.price.amount : 0;
    let contractPeriod = sendQuotation && sendQuotation.selectedContractPeriod;
    let paylod = {
      email,
      connectionDetails: [
        {
          address: {
            addressLine1: address && address.addressString,
            city: address && address.city,
            pincode: address && address.pincode
          },
          planDetail: {
            price: {
              amount: arc,
              taxPercentage: sendQuotation && sendQuotation.price && sendQuotation.price.taxPercentage,
              discount: sendQuotation && sendQuotation.price && sendQuotation.price.discount,
              otc: otc
            },
            totalPrice: arc * contractPeriod + otc,
            planPeriod: contractPeriod * 12,
            speed: sendQuotation && sendQuotation.speed,
            service: sendQuotation && sendQuotation.service
          }
        }
      ]
    };
    setIsLoading(true);
    sendPricingProposal(paylod)
      .then((res) => {
        setButtonDisabled(false);
        setIsLoading(false);
        setConfirmationPopup(!confirmationPopup);
      })
      .catch((err) => {
        setConfirmationPopup(!confirmationPopup);
        setButtonDisabled(false);
        setIsLoading(false);
      });
  };

  return (
    <React.Fragment>
      {getArc && getArc !== 0 ? (
        <div className="send-email-propodsl" onClick={openConfirmationPopup}>
          <i className="material-icons vertical-align">mail_outline</i> Email Pricing Proposal
        </div>
      ) : (
        ''
      )}

      {confirmationPopup && (
        <div className={`${disabled ? 'btnDisabled' : ''}`}>
          <EmailPricingProposal
            title="Email Pricing Proposal"
            content="Please provide the email address to send the Pricing Proposal"
            onSubmit={sendProposal}
            onCancel={openConfirmationPopup}
            isLoading={isLoading}
          ></EmailPricingProposal>
        </div>
      )}
    </React.Fragment>
  );
};

export default EmailProposal;
